"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _axios = _interopRequireDefault(require("axios"));
var _intlDesignUi = require("@tencent/intl-design-ui");
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E5%8A%A8%E4%BD%9C--page
 */

_axios.default.defaults.withCredentials = true;
_axios.default.defaults.crossDomain = true;
_axios.default.defaults.headers.post['Content-Type'] = 'application/json';
function _default({
  key,
  // {number} 用于标识每一个 action 实例的全局唯一且持久化的 key
  data,
  // {object} 数据表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
}) {
  const title = data.title,
    desc = data.desc,
    btnText = data.btnText,
    link = data.link;
  (0, _axios.default)({
    method: 'get',
    url: '/render/api/configsolution/getUserInfo'
  }).then(({
    data
  }) => {
    var _data$data;
    // 已登录回来的
    if ((data === null || data === void 0 ? void 0 : data.code) === 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.uin) {
      return;
    }
    _intlDesignUi.Modal.alert({
      size: 'small',
      icon: 'info-circle',
      title: title,
      content: desc,
      btnOkMsg: btnText,
      showCloseIcon: true,
      onOk() {
        location.href = `/login?s_url=${encodeURIComponent(location.href)}`;
      }
    });
  });
}